import axios from 'axios'

const env = window.Cypress ? window.Cypress.env() : process.env

export default class UnifiedSchedulingClient {
  constructor () {
    this.client = axios.create({
      baseURL: env.VUE_APP_UNIFIED_SCHEDULING_SERVICE_DOMAIN,
      headers: {
        'x-api-key': env.VUE_APP_UNIFIED_SCHEDULING_SERVICE_API_KEY
      }
    })
  }

  getPracticeMapping (practiceUuid) {
    return this.client.get(`v1/tebra/practice/${practiceUuid}/practice/mapping`)
  }

  getLocationMapping (practiceUuid, locationId) {
    return this.client.get(`v1/tebra/practice/${practiceUuid}/location/${locationId}/mapping`)
  }

  getProviderMapping (practiceUuid, providerId) {
    return this.client.get(`v1/tebra/practice/${practiceUuid}/provider/${providerId}/mapping`)
  }
}
